// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"3fa5958d86a548fb0ab2539ddac6e71df3d7d465"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/storefront/3fa5958d86a548fb0ab2539ddac6e71df3d7d465";import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';

import { filterSentrySpan } from '@utils/sentryFilters';

const envVars = getConfig().publicRuntimeConfig;

Sentry.init({
  dsn: envVars.SENTRY_DSN || '',
  release: envVars.SENTRY_RELEASE || '',
  tracesSampleRate: 0.05,
  debug: false,
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['storefront'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
  beforeSendSpan: filterSentrySpan,
});
